<template>
  <div class="kui-checkbox" :ref="options.field">
    <span v-show="options.title" class="kui-checkbox-title">{{titleName}}</span>
    <kui-validatebox ref='validator' :options='options'>
      <div slot="content">
        <el-checkbox v-model="checkAll" @change="handleCheckAllChange" v-if='options.hasChooedAll || isMulti'>全选
        </el-checkbox>
        <el-checkbox-group v-model="choosedValues" @change="handleCheckedOptsChange" v-if='isMulti'
          :disabled="disabled">
          <el-checkbox v-for="opt in options.value" :label="opt.label" :key="opt.label" v-if='isMulti'>{{opt.val}}
          </el-checkbox>
        </el-checkbox-group>
        <el-checkbox v-else v-model="choosedValues" @change="handleCheckedOptsChange" :label="options.value"
          :disabled="disabled">{{options.value}}</el-checkbox>
      </div>
    </kui-validatebox>
  </div>
</template>
<script>
export default {
  name: "kui-checkbox",
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: function () {
    return {
      loading: false,
      disabled: false,
      value: [],
      checkAll: false,
      choosedValues: [],
      isPassValidate: true,  //校验是否通过
    };
  },
  computed: {
    titleName () {
      return this.options.title ? this.options.title + ":" : "";
    },
    isMulti () {
      return _.isArray(this.options.value) ? true : false;
    }
  },
  watch: {
    choosedValues (v) {
      this.value = v.join(this.options.separator || ",");
    }
  },
  methods: {
    //全选
    handleCheckAllChange (val) {
      if (val) {
        let arr = [];
        this.options.value.map(v => {
          arr.push(v.label);
        });
        this.choosedValues = arr;
      } else {
        this.choosedValues = [];
      }
    },
    handleCheckedOptsChange (value) {
      if (this.choosedValues.length == this.options.value.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      };
    },
    hideTips () {
      this.isPassValidate = true;
      this.$refs.validator.hideTips();
    },
    validate (v) {
      this.isPassValidate = this.$refs.validator.validate(this.value);
      return this.isPassValidate;
    },
    getValue: function () {
      return this.value;
    },
    setValue: function (value) {
      if (_.isArray(value)) {
        this.choosedValues = value;
      } else {
        this.choosedValues = value.split(" ");
      }
    },
    setEnabled: function () {
      this.disabled = false;
    },
    setDisabled: function () {
      this.disabled = true;
    },
    getData: function () {
      return {
        [this.options.field]: this.getValue()
      };
    }
  },
  mounted () {

  },

};
</script>
<style lang='less' scoped>
.kui-checkbox {
  display: flex;
  .kui-checkbox-title {
    margin-right: 8px;
  }
}
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/checkbox/index.vue